import React from "react";
import { BrowserRouter as Router,  Routes,Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import QRModal from "./pages/QRCodePage.js";
import HomePage from "./pages/HomePage";
import PrivateRoute from "./components/PrivateRoute.js";
import "react-toastify/dist/ReactToastify.css";
import Items from "./components/CreateItem.js";
import Bills from "./components/GenerateBill.js";
import GlobalView from "./components/GobalView.js";
import ManualSale from './components/ManualSold.js';
import ScaningSale from './components/ScannedSold.js';
import StockReports from './components/Reports.js';
import SaleHistory from './components/SoldHistory.js';
import Stocks from "./components/ItemsView.js"

function App() {


  return (
    
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/QR" element={<QRModal />} />
          <Route path="/beverages" element={<PrivateRoute element={<HomePage />} />}>
            <Route path="Brands" element={<Items />} />
            <Route path="bills" element={<Bills />} />
            <Route path="global-item-details" element={<GlobalView />} />
            <Route path="stocks" element={<Stocks />} />
            <Route path="stock-reports" element={<StockReports />} />
            <Route path="manually" element={<ManualSale />} />
            <Route path="scanner" element={<ScaningSale />} />           
            <Route path="sales-history" element={<SaleHistory />} />
          </Route>
        </Routes>

      </Router>
  
  );
}

export default App;
